export default {"src":"/_next/static/media/DraftKings.6d13dffc.svg","height":33,"width":57,"blurWidth":0,"blurHeight":0};